import { render, staticRenderFns } from "./TeamsClientsTable.vue?vue&type=template&id=089abb6c&"
import script from "./TeamsClientsTable.vue?vue&type=script&lang=js&"
export * from "./TeamsClientsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports